/**
 * Dashboard Widget Component
 *
 * Reusable card component for dashboard widgets.
 */

'use client';

import { ReactNode } from 'react';

interface DashboardWidgetProps {
  title: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function DashboardWidget({
  title,
  icon,
  action,
  children,
  className = '',
}: DashboardWidgetProps) {
  return (
    <div className={`bg-surface rounded-lg border border-border-muted ${className}`}>
      <div className="p-6 border-b border-border-muted">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {icon && <div className="text-accent">{icon}</div>}
            <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          </div>
          {action && <div>{action}</div>}
        </div>
      </div>
      <div className="p-6">{children}</div>
    </div>
  );
}
